/* eslint-disable */
if(document.getElementsByClassName('begindate').length > 0) {
gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {

  if(document.getElementsByClassName('begindate').length > 0) {
    var begindate = jQuery('.begindate .datepicker').attr('name');
    begindate = begindate.substring('input_'.length);
  }
  if(document.getElementsByClassName('enddate').length > 0) {
    var enddate = jQuery('.enddate .datepicker').attr('name');
    enddate = enddate.substring('input_'.length)
  }

    if ( fieldId == begindate ) {
      optionsObj.minDate = 0;
      optionsObj.onClose = function (dateText, inst) {
        if( dateText != '' ) {
          jQuery('.enddate .datepicker').datepicker('option', 'minDate', dateText).datepicker('setDate', dateText);
          var beginDate = jQuery('.begindate .datepicker').datepicker('getDate'),
              dayNr = beginDate.getUTCDay();
          jQuery('.beginTime').setRadioTime(dayNr);
        }
      };
    }
    if ( fieldId == enddate ) {
      optionsObj.minDate = 0;
      optionsObj.onClose = function (dateText, inst) {
        if( dateText != '' ) {
          var endDate = jQuery('.enddate .datepicker').datepicker('getDate'),
              dayNr = endDate.getUTCDay();
          jQuery('.endTime').setRadioTime(dayNr);
        }
      };
    }
    return optionsObj;

});
}

if(document.getElementsByClassName('datepickerGeboortedatum').length > 0) {
  gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
    if(document.getElementsByClassName('datepickerGeboortedatum').length > 0) {
      var birthPicker = jQuery('.datepickerGeboortedatum .datepicker').attr('name');
      birthPicker = birthPicker.substring('input_'.length);
    }

      if ( fieldId == birthPicker ) {
        optionsObj.maxDate = 0;
      }
      return optionsObj;

  });
}


// WEBPACK FOOTER //
// ./scripts/legacy/modules/form-datepickers.js